import { createContext, useContext } from 'react';

interface MenuContextValue {
  /**
   * Whether selecting an item closes the menu. Mirrors `MenuButton`'s `autoClose`.
   */
  autoClose: boolean;
  /**
   * Whether a Radix `Content` is mounted around the items yet. False until the menu's first open,
   * while the items are rendered only so an empty menu can be detected before it is ever opened.
   */
  isInRadixMenu: boolean;
}

/**
 * Marks the subtree as living inside a `MenuButton` dropdown.
 *
 * Private to the menus module. `MenuItem` reads it to choose between its in-menu and standalone
 * markup, which is also what keeps a bare `<MenuItem>` rendered outside a menu working.
 */
export const MenuContext = createContext<MenuContextValue | undefined>(undefined);

/**
 * Returns the enclosing menu, or `undefined` when the caller is rendered outside one.
 */
export const useMenuContext = () => useContext(MenuContext);
